@if (loading) {
<app-loader></app-loader>
}
<div class="row">
  <div class="col-12 col-lg-6">
    <app-dynamic-breadcrumb [bgColor]="'transparent'" [fontSize]="'14px'" [lastLinkColor]="'rgba(196, 196, 205, 0.42)'"
      [fontColor]="'#c4c4cd'">
    </app-dynamic-breadcrumb>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div class="row header">Analytics Details</div>
  </div>
</div>
<p-accordion [value]="activeAccordionPanel" (valueChange)="activeAccordionPanel = $event">
  <p-accordion-panel value="0">
    <p-accordion-header class="QEaccordionheader">Query Filters & Controls</p-accordion-header>
    <p-accordion-content class="QEaccordioncontent">
      <div class="row">
        <div class="col-12">
          <form #queryEngineForm="ngForm">
            <div class="row form-row">
              <div class="col-1"><label>Query Type </label></div>
              <div class="col-2">
                <select id="queryTypeId" name="queryTypeId" [(ngModel)]="queryModel.queryTypeId"
                  class="query-engine-form-control w-100 select-arrow" (change)="onQueryTypeChange()">
                  <option value='1'>Reports and Audits</option>
                  <option value='0'>IRR Tables</option>
                  <option value='2'>User Defined Queries</option>
                </select>

              </div>

              @if (queryModel?.queryTypeId == 0) {
              <div class="col-1"></div>
              <div class="col-2"><label>Template Type </label></div>
              <div class="col-2">
                <select id="queryList" name="queryList" [(ngModel)]="queryModel.queryId"
                  class="query-engine-form-control w-100 select-arrow" (change)="onTemplateTypeChange()">
                  @for (query of queryList; track query) {
                  <option [selected]="query.queryId == queryModel.queryId" value={{query.queryId}}>
                    {{query.displayName}}
                  </option>
                  }
                </select>

              </div>
              }
              @if (queryModel?.queryTypeId == 2) {
              <div class="col-1"></div>
              <div class="col-2"><label>User Defined Query Type </label></div>
              <div class="col-2">
                <select id="userqueryList" name="userqueryList" [(ngModel)]="queryModel.userDefinedQueryTypeId"
                  class="query-engine-form-control w-100 select-arrow" (change)="onUserDefinedQueryTypeChange()">
                  @for (query of userDefinedqueryList; track query) {
                  <option [selected]="query.userDefinedQueryTypeId == queryModel.userDefinedQueryTypeId"
                    value={{query.userDefinedQueryTypeId}}>
                    {{query.userDefinedQueryDisplayName}}
                  </option>
                  }
                </select>

              </div>
              }
            </div>
            @if (queryModel?.queryTypeId == 0) {
            <div class="row">
              <div class="col-1"><label>Description</label></div>
              <div class="col-11"><label id="SelectedDescription">{{queryModel.description}}</label></div>
            </div>
            }
            <div class="row form-row">
              <div class="col-1"><label>Report Pack</label></div>
              <div class="col-4">
                <app-report-pack-filter [(selectedReportPacks)]="selectedReportPack" [showOnlyValidReportPacks]="true"
                  [resetSelectionToken]="reportPackResetToken" [selectedRpIds]="queryModel.reportPackId"
                  [updateServiceOnRpSelection]="false" (selectedReportPacksChange)="onReportPackSelection()">
                </app-report-pack-filter>
                <br />
              </div>
              @if ((queryModel?.queryTypeId == 1 || userDefinedQueryModel?.queryTypeId == 1) &&
              queryModel?.reportPackId>0 && activeAccordionPanel == '0') {
              <div class="col-12">
                <div>
                  <p-treeTable #dt [value]="reportTreeListData" selectionMode="checkbox" class="table-irr"
                    [(selection)]="selectedNodes" (onNodeSelect)="preserveTreeScrollPosition()"
                    (onNodeUnselect)="preserveTreeScrollPosition()" (onNodeExpand)="preserveTreeScrollPosition()"
                    (onNodeCollapse)="preserveTreeScrollPosition()" [columns]="headerCols" [paginator]="true" [rows]="8"
                    [scrollable]="true" [scrollHeight]="'calc(100vh - 300px)'" sortField="ReportDisplayName"
                    sortOrder="1">
                    <ng-template pTemplate="paginatorleft">
                      <button class="btn btn-clear-filter hvr-shrink" type="button"
                        (click)="dt.reset();clearFilters();">
                        <span><i class="fas fa-times mr-1"></i> Clear Filters</span>
                      </button>
                    </ng-template>
                    <ng-template pTemplate="header" let-columns>
                      <tr>
                        @for (col of columns; track col) {
                        <th [ttSortableColumn]="col.field"> {{col.header}}
                          <p-treeTableSortIcon [field]="col.field"></p-treeTableSortIcon>
                        </th>
                        }
                      </tr>
                      <tr>
                        @for (col of columns; track col) {
                        <th>
                          @if (col.field !='' && col.field != 'ReportingType') {
                          <input type="text" class="w-100" placeholder="Filter Text"
                            [value]="dt.filters && dt.filters[col.field] ? dt.filters[col.field].value: ''"
                            (input)="dt.filter($event.target.value, col.field, 'contains')">
                          }
                          @if (col.field =='ReportingType') {
                          <p-multiSelect [options]="reportingTypeOptions"
                            (onChange)="dt.filter($event.value, 'ReportingType', 'in')" appendTo="body"
                            defaultLabel="Select Reporting Type" [(ngModel)]='selectedReportingTypes'>
                          </p-multiSelect>
                          }
                        </th>
                        }
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                      <tr>
                        <td>
                          <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                          <!-- <p-treeTableCheckbox [value]="rowNode"  ngDefaultControl [disabled]="false">
              </p-treeTableCheckbox> -->
                          {{rowData.DisplayName}}
                        </td>
                        <td>{{rowData.Description}}</td>
                        <td>{{rowData.ReportingType}}</td>
                        <td>{{rowData.TemplateName}}</td>
                        <td>@if (rowData.TemplateId) {
                          @if(rowData?.ReportingType == 'Audit' || rowData?.ReportingType == 'Exception'){
                          <button class="btn btn-modal-pos small-font hvr-shrink" type="button"
                            (click)="GetreportQueryResult(rowNode)"
                            [disabled]="(queryModel.reportPackId === null || queryModel.reportPackId == 0)">
                            <span>View</span>
                          </button>
                          }
                          <button class="btn btn-modal-pos small-font hvr-shrink" type="button"
                            (click)="DownloadreportQueryResult(rowNode)"
                            [disabled]="(queryModel.reportPackId === null || queryModel.reportPackId == 0)">
                            <span>Download</span>
                          </button>
                          }
                        </td>
                      </tr>
                    </ng-template>
                  </p-treeTable>
                </div>
              </div>
              }
              @if (queryModel?.queryTypeId != 1) {
              <div class="col-12 align-items-center">
                <button class="btn btn-modal-pos small-font hvr-shrink" type="button"
                  (click)="getQueryResult(selectedQueryTypeId != 2, selectedQueryTypeId == 2)"
                  [disabled]="(queryModel.reportPackId === null || queryModel.reportPackId == 0)">
                  <span>Get Query Result</span>
                </button>
              </div>
              }
            </div>

          </form>
        </div>
      </div>
    </p-accordion-content>
  </p-accordion-panel>
   @if(displaySaveQuerySection){
      <div class="row form-row">
        <div class="col-2"><label>New User Query Name </label></div>
        <div class="col-3">
          <input type="text" required minlength="4" maxlength="50" [disabled]="!enableSave" [(ngModel)]="userQueryName"
            class="user-query-form-control" id="userQueryName" name="userQueryName" pattern="^[A-Za-z0-9 _\-.]*$"
            trim-text />
        </div>

        <div class="col-5">
          <button class="btn btn-modal-pos small-font hvr-shrink" [disabled]="!enableSave || !userQueryName?.trim()" type="button"
            (click)="saveUserQuery()">
            <span>Save</span>
          </button>
        </div>
      </div>
      }
  @if (allowAccordionToggle == true) {
  <p-accordion-panel value="1">
    <p-accordion-header class="QEaccordionheader">Query Results</p-accordion-header>
    <p-accordion-content class="QEaccordioncontent">
     
      <div class="row form-row">
        <div class="col-12">
          <div class="DescHeader">Query Result Details : {{queryModel.selectedGridDetails}}</div>
          <div class="DescContent">Description : {{queryModel.selectedGridDetailDescription}}</div>
        </div>
      </div>

<div class="row form-row">
      <app-dynamic-grid [gridData]="gridData" [isCRUDEnabled]="false" [filter]="queryModel.filter"
        [sort]="queryModel.sortList" (modelChange)="updateQueryModel($event)"
        (downloadResults)="downloadQueryResult($event)">
      </app-dynamic-grid>
      </div>
    </p-accordion-content>
  </p-accordion-panel>
  }
</p-accordion>